import { gsap, CSSRulePlugin } from 'gsap/all';

gsap.registerPlugin(CSSRulePlugin); 

const loader = () => {
    const loaderTl =  gsap.timeline({
        paused: true,
    });
    
    if (document.querySelector('.hero')) {
        loaderTl.to(".hero__bg", {
            autoAlpha: 1,
            duration: 3,
            scale: 1,
            ease: "quart.out"
        }).to(".hero__obj, .hero__globe", {
            x: 0,
            scale: 1,
            duration: 5,
            autoAlpha: 1,
            rotate: 0,
            ease: "quart.out"
        }, 0.01).to(".hero__logo", {
            autoAlpha: 1,
            duration: 2,
            y: 0,
            filter: "blur(0px)",
            ease: "quart.out"
        }, 0.5).to(".hero__title, .hero__title--big", {
            autoAlpha: 1,
            duration: 2,
            y: 0,
            filter: "blur(0px)",
            ease: "quart.out"
        }, 0.65).to(".hero__text", {
            autoAlpha: 1,
            duration: 2,
            y: 0,
            filter: "blur(0px)",
            ease: "quart.out"
        }, 0.8).to(".hero .btn", {
            autoAlpha: 1,
            duration: 2,
            stagger: 0.1,
            y: 0,
            filter: "blur(0px)",
            ease: "quart.out"
        }, 0.95).to(".header", {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            duration: 0.65,
            ease: 'quart.out'
        }, 0.75).to(".header__logo, .header__menu li, .header__search", {
            autoAlpha: 1,
            duration: 1,
            ease: 'quart.out',
            stagger: 0.1,
            filter: "blur(0px)"
        }, 0.85);
    } else {
        loaderTl.to(".header", {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            duration: 0.65,
            ease: 'quart.out'
        }, 0.25).to(".header__logo, .header__menu li, .header__search", {
            autoAlpha: 1,
            duration: 1,
            ease: 'quart.out',
            stagger: 0.1,
            filter: "blur(0px)"
        }, 0.35);
    }

    loaderTl.play();
};

export default loader;